import React, { useContext } from "react";

import { NCRContext } from "views";
import { UserContext } from "components/routing";
import { useFormContext } from 'react-hook-form';

// import { Dropdown } from "components/form/prototypes";
import { Asterisk } from "components/form/prototypes";
import { InputLabel } from "components/form/prototypes";

const ResponsibleParty = () => {

  const { user } = useContext(UserContext)
  const { state } = useContext(NCRContext);
  const { register } = useFormContext();

  const isDisabled =
    ['QA', 'GM'].includes(user.role)
      ? state.ncr.status.id > 8
      : state.ncr.status.id > 1;

  // const { state, setState } = useContext(NCRContext);
  // const { user } = useContext(UserContext)

  // let users = []
  // const subDN = user.dn.match(/Users,(?<subDN>.*)/)?.groups?.subDN;
  // const data = state.users

  // for (let i = 0; i < data.length; i++) {
  //   const usersDN = data[i].dn.match(/Users,(?<subDN>.*)/)?.groups?.subDN;
  //   if (usersDN === subDN) {
  //     users.push({ id: i, name: data[i].displayName })
  //   }
  // }

  let liability = ""

  if (state.ncr.liability) {
    liability = state.ncr.liability.name;
  }
  const liabilities = ["External Sales", "Internal Sales", "Sales Support"]

  return (
    // <>
    //   <Asterisk />
    //   <Dropdown
    //     name='ncr.responsibleparty'
    //     label='Responsible Party'
    //     data={users}
    //     required={true} />
    // </>
    <>
      {liabilities.includes(liability) &&
        <>
          <Asterisk />
          <InputLabel
            name='ncr.responsibleparty'
            label='Responsible Party'
            ref={register({ required: true })}
            disabled={isDisabled} />
        </>
      }
    </>
  )
}

export { ResponsibleParty };
